import { useState } from 'react'
import { ChevronDown } from 'lucide-react'

export default function EventCard({ event }) {
  const [isOpen, setIsOpen] = useState(false)

  const getCategoryColor = (category) => {
    const colors = {
      'Cultural': 'from-kala-orange to-kala-yellow',
      'Art': 'from-kala-cyan to-kala-blue',
      'Media': 'from-kala-blue to-kala-cyan',
      'Literary': 'from-kala-orange to-kala-cyan',
      'Tech': 'from-kala-blue to-kala-yellow',
    }
    return colors[category] || 'from-kala-blue to-kala-cyan'
  }

  const getIconEmoji = (name) => {
    const icons = {
      'General Quiz': '🧠',
      'IT Quiz for CS Students': '💻',
      'Photography': '📸',
      'Solo Dance': '💃',
      'Group Dance': '👯',
      'Mehandi': '✨',
      'Reels': '🎬',
      'Speech': '🎤',
      'Gaming - BGMI': '🎮',
      'Gaming - Free Fire': '🔥',
      'Rangoli': '🪷',
      'Pencil Sketch': '✏️',
      'Singing': '🎵',
      'Coding for CS Students': '💻',
      'Essay Writing': '✍️',
      'Ad Mad Show': '🎭',
      'Water Painting': '🎨',
      'Treasure Hunt': '🗺️',
      'Best Out of Waste': '♻️',
    }
    return icons[name] || '🎉'
  }

  return (
    <div className="card-soft border-l-4 border-transparent overflow-hidden group" style={{
      borderImage: `linear-gradient(180deg, ${getCategoryColor(event.category).split(' ')[1]}, ${getCategoryColor(event.category).split(' ')[3]}) 1`
    }}>
      {/* Card Header */}
      <div className="p-6 pb-4">
        <div className="flex items-start justify-between mb-3">
          <div className="text-4xl">{getIconEmoji(event.name)}</div>
          <span className={`text-xs font-semibold px-3 py-1 rounded-full bg-gradient-to-r ${getCategoryColor(event.category)} text-white`}>
            {event.category}
          </span>
        </div>
        <h3 className="text-lg font-bold text-kala-primary mb-2">{event.name}</h3>
        <p className="text-sm text-kala-secondary">{event.description}</p>
      </div>

      {/* Accordion */}
      <div className="accordion-item border-0 border-t border-kala-border rounded-none">
        <button
          className={`accordion-button ${isOpen ? 'active' : ''}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="text-sm font-medium">Details & Rules</span>
          <ChevronDown
            size={20}
            className={`transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
          />
        </button>
        <div className={`accordion-content ${isOpen ? 'open' : ''}`}>
          <div className="space-y-4 text-sm text-kala-secondary">
            {event.rules && (
              <div>
                <h4 className="font-semibold text-kala-primary mb-2">Rules:</h4>
                <ul className="list-disc list-inside space-y-1">
                  {event.rules.map((rule, idx) => (
                    <li key={idx}>{rule}</li>
                  ))}
                </ul>
              </div>
            )}
            {event.criteria && (
              <div>
                <h4 className="font-semibold text-kala-primary mb-2">Judging Criteria:</h4>
                <ul className="list-disc list-inside space-y-1">
                  {event.criteria.map((criterion, idx) => (
                    <li key={idx}>{criterion}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Register Button */}
      <div className="p-6 pt-4">
        <a
          href={event.registerLink}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full btn-gradient-blue-cyan text-center block text-sm"
        >
          Register for Event
        </a>
      </div>
    </div>
  )
}
